<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records h-100">
            <div class="row h-100">
                <div class="col-12 mb-4 dan-reports h-100">
                    <div class="bg-white border-radius-5 p-5 h-100">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row justify-content-center pt-3">
                                    <div class="col-md-6 text-center">
                                        <h2>DNA Reports</h2>
                                        <p>Learn how your health ties back to nutrition and genes.</p>
                                        <h3>DNA Content</h3>
                                        <router-link class="btn btn-blue dna-profile" to="/dna-connect">Add your DNA profile now</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Dna-profile",
        data() {
            return {};
        },
        created(){
           this.pageName('DNA Reports')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/dna/add-dna-profile.vue